import { CSSProperties } from "react";
import { LOGO_PATH } from "./LogoMark";

type LoopWatermarkProps = {
  /** How far it drifts on scroll (parallax depth). */
  distance?: number;
  /** Override placement, e.g. { top: "auto", bottom: "-20%" }. */
  style?: CSSProperties;
};

/**
 * The logo loop drawn huge and faint behind a dark section, drifting slower
 * than the content (parallax). Purely decorative.
 * Parent section needs `position: relative; overflow: hidden; isolation: isolate`.
 */
const LoopWatermark = ({ distance = 120, style }: LoopWatermarkProps) => (
  <svg
    viewBox="0 0 50 40"
    className="is-watermark is-parallax"
    aria-hidden="true"
    style={{ ["--is-parallax-distance" as string]: `${distance}px`, ...style } as CSSProperties}
  >
    <circle cx="6" cy="6" r="4.5" fill="var(--is-border-on-dark)" />
    <path
      d={LOGO_PATH}
      fill="none"
      stroke="var(--is-border-on-dark)"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

export default LoopWatermark;
